export default [
  {
    method: "getSwitchStatus",
    type: "GET",
    path: "/api/komoe/webpay/switch",
    mode: "pay",
    params: ["distribution_region"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  {
    method: "getCurrencyList",
    type: "GET",
    path: "/api/komoe/webpay/currency_list",
    mode: "pay",
    params: ["distribution_region", "game_id"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  {
    method: "getGameList",
    type: "GET",
    path: "/api/komoe/webpay/game_list",
    mode: "pay",
    params: ["distribution_region"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  {
    method: "getRoleList",
    type: "GET",
    path: "/api/komoe/webpay/user/role_list",
    mode: "pay",
    params: ["distribution_region", "game_base_id"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  {
    method: "getProductList",
    type: "GET",
    path: "/api/komoe/webpay/product_list",
    mode: "pay",
    params: ["distribution_region", "game_id", "currency", "pay_mode"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  {
    method: "getChannelList",
    type: "GET",
    path: "/api/komoe/webpay/channel_list",
    mode: "pay",
    params: ["distribution_region", "game_base_id", "currency"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  {
    method: "addPayOrder",
    type: "POST",
    path: "/api/komoe/webpay/add_order",
    mode: "pay",
    params: [
      "distribution_region",
      "game_base_id",
      "game_id",
      "cp_server_id",
      "cp_role_id",
      "product_id",
      "product_name",
      "marketing_desc_1",
      "marketing_desc_2",
      "product_price",
      "currency",
      "pay_mode",
      "payment_type",
      "captcha_token",
      "captcha_code",
    ],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  {
    method: "getOrderDetail",
    type: "GET",
    path: "/api/komoe/webpay/order_detail",
    mode: "pay",
    params: ["distribution_region", "order_no"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  {
    method: "getOrderHistory",
    type: "GET",
    path: "/api/komoe/webpay/order_history",
    mode: "pay",
    params: ["distribution_region", "page_num", "page_size"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  {
    method: "getCaptcha",
    type: "POST",
    path: "/web/captcha/img/captcha",
    mode: "passport",
    params: ["distribution_region"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  {
    method: "setCaptcha",
    type: "POST",
    path: "/komoe/web/captcha/verify/captcha",
    mode: "passport",
    params: ["img_token", "captcha"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  {
    method: "getOrderResult",
    type: "GET",
    path: "/api/komoe/webpay/order_result",
    mode: "pay",
    params: ["distribution_region", "pay_order_no"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  // kome支付相关api

  // // 1.获取平台充值开关状态接口
  {
    method: "getKomoeSwitch",
    type: "GET",
    path: "/api/web/pay/switch",
    mode: "pay",
    params: [],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  // // 2.获取支持网页支付游戏信息接口
  {
    method: "getKomoeGameList",
    type: "GET",
    path: "/api/web/pay/game_list",
    mode: "pay",
    params: [],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  //// 3.获取游戏中用户的角色信息接口
  {
    method: "getKomoeRoleList",
    type: "GET",
    path: "/api/web/pay/user/role_list",
    mode: "pay",
    params: ["game_base_id"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  // // 4.获取游戏可购商品接口
  {
    method: "getKomoeProductList",
    type: "GET",
    path: "/api/web/pay/product_list",
    mode: "pay",
    params: ["game_id"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  // 4.2获取游戏可购商品接口
  {
    method: "getKomoeProductList2",
    type: "GET",
    path: "/api/web/pay/product_list/v2",
    mode: "pay",
    params: ["game_id"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  // // 5.获取支付方式接口
  {
    method: "getKomoeChannelList",
    type: "GET",
    path: "/api/web/pay/channel_list",
    mode: "pay",
    params: ["game_base_id"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  // // 6.用户下单接口
  {
    method: "addKomoePayOrder",
    type: "POST",
    path: "/api/web/pay/add_pay_order",
    mode: "pay",
    params: [
      "game_base_id",
      "game_id",
      "cp_server_id",
      "cp_role_id",
      "product_id",
      "product_name",
      "marketing_desc_1",
      "marketing_desc_2",
      "product_price",
      "currency",
      "pay_mode",
      "payment_type",
      "captcha_token",
      "captcha_code",
      "region",
      "addExtra",
    ],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  // // 7.订单详情查询接口
  {
    method: "getKomoeOrderDetail",
    type: "GET",
    path: "/api/web/pay/order_detail",
    mode: "pay",
    params: ["order_no","region"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  // // 8.充值记录查询接口
  {
    method: "getKomoeOrderHistory",
    type: "GET",
    path: "/api/web/pay/order_history",
    mode: "pay",
    params: ["page_num", "page_size","region"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  // // 9.获取图片验证码接口
  {
    method: "getKomoeCaptcha",
    type: "GET",
    path: "/api/web/pay/get_captcha",
    mode: "pay",
    params: [],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
  // // 10.支付结果查询接口
  {
    method: "getKomoeOrderResult",
    type: "GET",
    path: "/api/web/pay/order_result",
    mode: "pay",
    params: ["pay_order_no","region"],
    options: { withCredentials: true, cache: false },
    switch: true,
  },
];
